import React from "react";
import { OfferingDetail } from "../components/OfferingDetail";
export default function BrainPage({ onDemo }) { return <OfferingDetail slug="brain" onDemo={onDemo} />; }